import { inject, EnvironmentInjector, runInInjectionContext } from '@angular/core';
import { I18nService } from "./services/i18n.service";

export function i18nInitializer() {
  const injector = inject(EnvironmentInjector);
  return () => {
    return runInInjectionContext(injector, () => {
      const i18n = inject(I18nService);
      return i18n.load('br');
    });
  };
}